import { render, staticRenderFns } from "./DisasterClassSelector.vue?vue&type=template&id=268da35a"
import script from "./DisasterClassSelector.vue?vue&type=script&lang=js"
export * from "./DisasterClassSelector.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./DisasterClassSelector.vue?vue&type=style&index=1&id=268da35a&prod&lang=css"
import style2 from "./DisasterClassSelector.vue?vue&type=style&index=2&id=268da35a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports